import { useSelector } from 'react-redux';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { H4 } from 'foundations-components/transitional/components/H4';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCreateNewEditorForm } from 'FormsUI/hooks/useCreateNewEditorForm';
import { getFormCreationRequestState } from 'FormsUI/selectors/FormCreation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateFormSelectableBox = ({
  disabled,
  heading,
  description,
  illustrationName,
  onClick
}) => /*#__PURE__*/_jsx(Tooltip, {
  disabled: !disabled,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "newCreateForm.panel.tooltips.createDisabled"
  }),
  children: /*#__PURE__*/_jsx(SelectableBox, {
    type: "default",
    block: true,
    disabled: disabled,
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      gap: 8,
      justify: "between",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: illustrationName,
        height: 74,
        width: 74
      }), /*#__PURE__*/_jsxs(View, {
        as: "div",
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "200",
          children: heading
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: description
        })]
      })]
    })
  })
});
const CreateFormPanel = ({
  closeSidePanel
}) => {
  const formCreationRequestState = useSelector(getFormCreationRequestState);
  const {
    onCreateFromScratchClick,
    onCreateFromTemplateClick
  } = useCreateNewEditorForm();
  const isSelectableBoxDisabled = formCreationRequestState.isPending();
  return /*#__PURE__*/_jsxs(Panel, {
    width: 500,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: closeSidePanel
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCreateForm.panel.getStarted"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(PanelSection, {
        children: /*#__PURE__*/_jsxs(List, {
          children: [/*#__PURE__*/_jsx(View, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(CreateFormSelectableBox, {
              disabled: isSelectableBoxDisabled,
              heading: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "newCreateForm.panel.headings.startFromScratch"
              }),
              description: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "newCreateForm.panel.descriptions.createFromScratch"
              }),
              illustrationName: "building",
              onClick: onCreateFromScratchClick
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(CreateFormSelectableBox, {
              disabled: isSelectableBoxDisabled,
              heading: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "newCreateForm.panel.headings.startFromTemplate"
              }),
              description: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "newCreateForm.panel.descriptions.createFromTemplate"
              }),
              illustrationName: "marketing-templates",
              onClick: onCreateFromTemplateClick
            })
          })]
        })
      })
    })]
  });
};
export default CreateFormPanel;